import { useState } from 'react';
import './ContactForm.css';
import contactImage from '../../assets/social.jpg';

const ContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(e.target);
    const data = {
      nome: formData.get('user_name'),
      email: formData.get('user_email'),
      telefone: formData.get('user_phone'),
      tipo_evento: formData.get('event_type'),
      mensagem: formData.get('message')
    };

    try {
      const response = await fetch(
        'https://script.google.com/macros/s/AKfycbzRSyeZ1FbEsT38eVky2RrQa0PD4sFNqiKwnAvRdkQI4cc6yBSzB7W87Uoe4pp6evL5AA/exec', // Substitua pela URL do seu web app',
        {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(data).toString()
        }
      );

      setShowModal(true);
      e.target.reset();
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const Modal = () => (
    <div className="success-modal">
      <div className="modal-content">
        <i className="fas fa-check-circle"></i>
        <h3>Mensagem Enviada com Sucesso!</h3>
        <p>Agradecemos seu contato. Nossa equipe entrará em contato em até 24 horas úteis através do telefone ou email fornecido.</p>
        <p>Enquanto isso, que tal nos seguir no Instagram?</p>
        <div className="modal-buttons">
          <a 
            href="https://www.instagram.com/acjlocacoes/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="instagram-button"
          >
            <i className="fab fa-instagram"></i>
            Seguir no Instagram
          </a>
          <button onClick={() => setShowModal(false)} className="close-button">
            Fechar
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <section id="contato" className="contact">
      <div className="contact-container">
        <div className="contact-content" data-aos="fade-right">
          <div className="contact-header">
            <h2>Vamos Criar Algo Incrível Juntos</h2>
            <p>
              Entre em contato conosco para discutir seu próximo evento e descobrir 
              como podemos torná-lo extraordinário com nossas soluções em painéis de LED.
            </p>
          </div>

          <div className="contact-info">
            <div className="info-item">
              <i className="fas fa-mobile-alt"></i>
              <div>
                <h4>WhatsApp</h4>
                <p>(31) 97203-5157</p>
              </div>
            </div>
            
            <div className="info-item">
              <i className="fas fa-envelope"></i>
              <div>
                <h4>Email</h4>
                <p>contato@acjlocacoes.com.br</p>
              </div>
            </div>
            
            <div className="info-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h4>Localização</h4>
                <p>Belo Horizonte, MG</p>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <input 
                type="text" 
                name="user_name" 
                placeholder="Seu nome"
                required 
              />
            </div>

            <div className="form-group">
              <input 
                type="email" 
                name="user_email" 
                placeholder="Seu e-mail"
                required 
              />
            </div>

            <div className="form-group">
              <input 
                type="tel" 
                name="user_phone" 
                placeholder="Seu telefone"
                required 
              />
            </div>

            <div className="form-group">
              <select name="event_type" required>
                <option value="">Tipo de evento</option>
                <option value="corporate">Evento Corporativo</option>
                <option value="show">Show ou Festival</option>
                <option value="social">Evento Social</option>
                <option value="other">Outro</option>
              </select>
            </div>

            <div className="form-group">
              <textarea 
                name="message" 
                placeholder="Conte-nos sobre seu evento"
                rows="4"
                required
              ></textarea>
            </div>

            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
            </button>

            {showModal && <Modal />}
          </form>
        </div>

        <div className="contact-image" data-aos="fade-left">
          <img src={contactImage} alt="Painel de LED em evento" />
        </div>
      </div>
    </section>
  );
};

export default ContactForm; 
